import { create } from "zustand";

export type EntityFormRequest = {
  module: string;
  mode: "create" | "edit";
  id?: string | number | null;
  source?: "lookup-panel" | "inline-button" | "page-create" | "grid-edit" | "bulk-grid" | "voucher-entry" | "nested-create" | "bank-page" | "bank-account-drawer" | "users";
  initialValues?: Record<string, unknown>;
  parentContext?: Record<string, unknown>;
  onSuccess?: (saved: unknown) => void;
  onCancel?: () => void;
};

type EntityFormState = {
  open: boolean;
  request: EntityFormRequest | null;
  openForm: (request: EntityFormRequest) => void;
  closeForm: () => void;
};

export const useEntityFormStore = create<EntityFormState>((set) => ({
  open: false,
  request: null,
  openForm: (request) => set({ open: true, request }),
  closeForm: () => set({ open: false, request: null })
}));
